

































import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { OrgsApi, Org } from '../../api';
import { Validation } from 'vuelidate';
import { VueSelect } from 'vue-select';

@Component({
	components: { VueSelect },
})
export default class OrgSuggest extends Vue {
	// computed
	get validationState() {
		if (this.validator) {
			return this.validator.$dirty && this.validator.$invalid;
		}
		return null;
	}

	public collapseVisible = true;
	@PropSync('org') public localOrg!: object;

	@Prop(Object)
	public readonly validator?: Validation;

	@Prop(Boolean)
	public readonly disabled?: boolean;

	@Prop(Boolean)
	public readonly partner?: boolean;

	public options: Org[] = [];
	private api: OrgsApi;

	constructor() {
		super();
		this.api = new OrgsApi();
		this.debouncedOptions = debounce(this.fetchOptions, 100);
	}

	public onSelect(item: any) {
		if (this.validator) {
			this.validator.$touch();
		}
		this.collapseVisible = !this.collapseVisible;
		const output = {
			...item,
			address: item?.address?.length > 0 ? item.address[0] : { fullAdr: '', region: '' },
		};
		// extracts address from array

		if (item.admin === null) {
			output.admin = { id: '', name: '', phone: '', email: '' };
		}
		if (item.subscription === null) {
			output.subscription = {
				paymentMethod: '',
				accountApproved: '',
				directDebitDate: '',
				accountName: '',
				accountNumber: '',
			};
		}
		output.activeSiteId = '';
		this.localOrg = output;
		this.$emit('exist', true);
	}

	public onSearch(search: string) {
		this.collapseVisible = true;
		if (!search || search.length < 1) {
			this.debouncedOptions.cancel();
			//   // loading(false);
			return;
		}
		this.debouncedOptions.cancel();
		this.debouncedOptions(search);
	}

	public clearOrg() {
		this.$emit('update:org', {
			id: undefined,
			name: '',
			farmSourceName: '',
			farmSourceNumber: '',
			address: { fullAdr: '', region: '' },
			admin: { id: undefined, name: '', email: '', phone: '' },
			subscription: {
				paymentMethod: '',
				accountApproved: '',
				directDebitDate: '',
				accountName: '',
				accountNumber: '',
			},
		});
		this.$emit('exist', false);
	}

	public async fetchOptions(search: string) {
		const options = {
			params: {
				include: 'admin,address,subscription,sites',
				'filter[name]': search,
				// 'page[limit]': 10,
			},
		};
		const response = await this.api.getOrgs(options);
		if (this.partner) {
			this.options = response.data.data.filter(o => o.orgType === 'partner') || [];
		} else {
			this.options = response.data.data || [];
		}
	}

	private readonly debouncedOptions: any = () => {
		return [];
	};
}
